export default {
    bodyText: {
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "32px",
        color: "#262626",
        textAlign: "center",
    },

    messageBox: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        padding: "30px"
    },

    button: {
        width: "100px"
    }
}